export const getNextElementOnKey = (keyCode, elementList, currentElement) => {
    if (elementList.length === 0) {
        return currentElement;
    }
    const currentIndex = currentElement ? elementList.indexOf(currentElement) : 0;
    const firstElementIndex = 0;
    const lastElementIndex = elementList.length - 1;
    let newIndex;
    switch (keyCode) {
        case 'ArrowDown':
            newIndex = currentIndex + 1;
            break;
        case 'ArrowUp':
            newIndex = currentIndex - 1;
            break;
        case 'Home':
            newIndex = firstElementIndex;
            break;
        case 'End':
            newIndex = lastElementIndex;
            break;
        default:
            newIndex = 0;
    }
    if (newIndex > lastElementIndex) {
        newIndex = lastElementIndex;
    }
    if (newIndex < firstElementIndex) {
        newIndex = firstElementIndex;
    }
    return elementList[newIndex];
};
